<template>
<div>
    <el-dialog class="doc_send_make_dialog" title="发送文书" width="60%" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" :before-close="recordClose" center>
        <div class="doc_send_wrap">
            <el-form :model="docsendForm" ref="docsendForm" label-position="left" label-width="100px" size="small" :hide-required-asterisk="true">
                <el-form-item label="选择文书类型">
                    <el-select v-model="docsendForm.type" style="width:450px;" placeholder="请选择" @change="changeDocType">
                        <el-option v-for="item in typeOptions" :key="item.docType" :label="item.docName" :value="item.docType">
                        </el-option>
                    </el-select>
                    <a v-if="docsendForm.docTemp && docsendForm.docTemp.value" class="doc_template" @click="downLoadTemplate">点击下载模板</a>
                </el-form-item>
              <el-form-item v-if="docsendForm.type == 'GZZC_OTHER'" label="文书名称" prop="docName">
                <el-input style="width: 47.5%" v-model="docsendForm.docName"></el-input>
              </el-form-item>
                <el-form-item label="选择文件" prop="fileName">
                    <el-row>
                        <el-col :span="16">
                            <el-input v-for="(item, index) in fileUploads.fileList" v-model="item.name" :key="index" placeholder="请上传文书" clearable @clear="handleClearFile(index)"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-upload class="upload-doc" ref="upload"
                                       :action="fileUploads.actionUrl"
                                       :accept="fileUploads.acceptType"
                                       :headers="fileUploads.flk"
                                       :http-request="handleRequestRecord"
                                       :on-remove="handleRemove"
                                       :on-change="handleChange"
                                       :show-file-list="false"
                                       :file-list="fileUploads.fileList"
                                       :limit="fileUploads.limit"
                                       :multiple="fileUploads.multiple"
                                       :auto-upload="false">
                                <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                            </el-upload>
                        </el-col>
                    </el-row>
                    <div class="el-upload__tip">{{fileUploads.acceptTip}}</div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <div style="width: 100%; margin: 20px 25px; text-align: left" v-if="docsendForm.type != 'GZZC_MEDIATION_STAMP' && docsendForm.type != 'GZZC_BACKOUT_DECISION_BOOT_STAMP'">
                <div style="font-size: 14px; color: #0083c8">发送签字人员</div>
                <div style="display: flex; margin-top: 10px">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChanged" style="margin-right: 30px">全选</el-checkbox>
                    <el-checkbox-group v-model="sendUserList" @change="handleSendArrChanged">
                        <el-checkbox v-for="(item, index) in confirmList" :key="index" :label="item.userId" name="type">{{item.userName}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div>
                <el-button @click="recordClose(null)">取 消</el-button>
                <el-button type="primary" :loading="BtnLoading" @click="handleSendBook(0)">发送</el-button>
            </div>
        </div>
    </el-dialog>
</div>


</template>

<script>
import {
    getMediationRoomUserInfoList,
    queryDocTempList,
    createClerkRecord,
    sendClerkRecordGzzc
} from "@/api/casespace_doclist.js";

import {sendAsyncMediationDoc} from "../../../api/casespace";
import {
  getFileExtendName,
  getStore, toastSuc, toastWarning
} from '@/utils/utils.js'
import config from '@/config/config.js'
import {maxFileLength, maxFileTip, maxFileWarning} from "../../../utils/utils";
export default {
    props: ['wsLink', 'currentRoomId'],
    data() {
        return {
            dialogVisible: false,
            docsendForm: {
                resource: "2",
                type: "GZZC_MEDIATION_RECORDS",
                fileName: "",
                files: null,
              docName:''  //其他  文书名称
            },
            typeOptions: [{
                docName: '调解笔录(仲裁员版)',
                docType: 'GZZC_MEDIATION_RECORDS'
            }],
            //模板下载地址
            templateUrl: '',
            fileUploads: {
                actionUrl: `${config.baseURL}/gzzc/docBook/upload`,
                acceptType: '.pdf,.doc,.docx',
                acceptTip: '只能上传pdf/doc/docx文件，'  + maxFileTip,
                flk: {
                    JWTToken: getStore('flk'),
                    appName: config.appName,
                    cType: 'PC'
                },
                fileData: {
                    isView: 'NOVIEW'
                },
                limit: 1,
                multiple: false,
                fileList: [],
                fileJson: []
            },
            confirmList: [],
            sendUserList: [],
            isIndeterminate: false,
            checkAll: false,
            buttonStatus: false,
            BtnLoading: false,
            curCaseId: null,
            curMeetingId: null,
            curRoomUserList: {},
            curRoomUserIdList: [],
            docObj: {},
            fileUrl: '',
            clerkRecordDownloadUrl:'',
        }
    },
    created() {
        this.curCaseId = this.$route.query.caseid
        this.curMeetingId = this.$route.query.meetingid
    },
    methods: {
        openDocDialog(confirmList) {
            this.confirmList = confirmList
            console.log('opendialog-----')
            this.docsendForm = {
                resource: "2",
                type: "GZZC_MEDIATION_RECORDS",
                fileName: "",
                files: null,
                docName: ''  //其他  文书名称
            }

            let userData = {}
            this.getDocTempList()
            getMediationRoomUserInfoList({
                "id": this.curCaseId
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.forEach(element => {
                        userData[element.userId] = element
                    })
                    this.curRoomUserList = userData
                    this.curRoomUserIdList = res.data.data.map(item => {
                        return {
                            id: item.userId,
                            name: item.userName
                        }
                    })
                }
                this.dialogVisible = true
            }, err => {
                this.dialogVisible = true
            })
        },
        changeDocType(option) {
            this.docsendForm.docTemp = this.typeOptions.filter(function (item) {return item.docType == option})[0].docTemp
            if (option == 'GZZC_MEDIATION_STAMP' || option == 'GZZC_BACKOUT_DECISION_BOOT_STAMP' ) {
                this.fileUploads.acceptType = '.pdf,.doc,.docx,.png,.jpg,.jpeg'
                this.fileUploads.acceptTip = '上传一份pdf/doc/docx文件或多张png/jpg/jpeg图片，' + maxFileTip
                this.fileUploads.limit = 1000
                this.fileUploads.multiple = true
            } else {
                this.fileUploads.acceptType = '.pdf,.doc,.docx'
                this.fileUploads.acceptTip = '只能上传pdf/doc/docx文件，' + maxFileTip
                this.fileUploads.limit = 1
                this.fileUploads.multiple = false
            }
            this.fileUploads.option = option
        },
        recordClose(done) {
            this.$refs["docsendForm"].resetFields();
            done ? done() : this.dialogVisible = false
        },
        //获取笔录模板
        getDocTempList() {
            let param = {
                "onlineStatus": 1,
                "pageIndex": 1,
                "bizCode": 'gzzc_tj',
                "pageSize": 200
            }
            queryDocTempList(param).then(res => {
                if (res.data.code === 1000) {
                    if (res.data.data.list.length > 0) {
                        this.typeOptions = res.data.data.list
                        let that = this
                        this.docsendForm.docTemp = this.typeOptions.filter(function (item) {return item.docType == that.docsendForm.type})[0].docTemp
                    }
                }
            })
        },
        handleRemove(file, fileList) {
            //删除文件（上传）
            this.fileUploads.fileList = fileList
        },
        handleCheckAllChanged(val) {
            this.sendUserList = []
            if (val) {
                this.confirmList.forEach(item => {
                    this.sendUserList.push(item.userId)
                })
            }
            this.isIndeterminate = false;
        },
        handleSendArrChanged(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.confirmList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.confirmList.length;
        },
        handleChange(file, fileList) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                });
                fileList.pop()
                return
            }
            if (tempRet.index > 20) {
                this.$message({
                    type: 'warning',
                    message: '文件名不超过20个字符长度'
                })
                return false
            }

            if (fileList && fileList.length>1 && (this.fileUploads.option == 'GZZC_MEDIATION_STAMP' || this.fileUploads.option == 'GZZC_BACKOUT_DECISION_BOOT_STAMP')) {
                console.log('盖章版文书', this.fileUploads.option, fileList)
                let imageNum = 0, fileNum = 0
                fileList.forEach(item => {
                    if (item.raw.type.indexOf('image') >= 0) {
                        imageNum ++
                    } else {
                        fileNum ++
                    }
                })

                console.log('ppppppp', fileNum, imageNum)
                if (imageNum > 0 && fileNum > 0) {
                    this.$message.error('仅支持上传一份pdf/doc/docx文件或多张png/jpg/jpeg图片')
                    this.fileUploads.fileList = []
                    return false
                } else if (fileNum > 1) {
                    this.$message.error('仅支持上传一份pdf/doc/docx文件')
                    this.fileUploads.fileList = []
                    return false
                }

            }

            this.fileUploads.fileList = fileList
            this.docsendForm.fileName = file.name
        },
        handleRequestRecord(file) {
            console.log('handleRequestRecord 333333:', file)
            if (this.docsendForm.type == 'GZZC_MEDIATION_STAMP' || this.docsendForm.type == 'GZZC_BACKOUT_DECISION_BOOT_STAMP') {
                this.docsendForm.picFiles = this.docsendForm.picFiles || []
                this.docsendForm.picFiles.push(file.file)
            } else {
                this.docsendForm.files = file.file
            }
        },
        handleClearFile(index) {
            this.fileUploads.fileList.splice(index, 1)
        },
        handleSendBook(dtype) {
            let self = this
            self.$refs.upload.submit();
            if (this.docsendForm.type === 'GZZC_MEDIATION_STAMP' || this.docsendForm.type === 'GZZC_BACKOUT_DECISION_BOOT_STAMP') {
                this.sendUserList = []
                this.isIndeterminate = true
                this.confirmList.forEach(user => {
                    this.sendUserList.push(user.userId)
                })
            }
            if (!this.sendUserList || this.sendUserList.length == 0) {
                this.$message.warning('请选择发送签字人员')
                return
            }
            let params = new FormData()
            params.append('docId', '')
            params.append('userIdList', self.sendUserList)
            params.append('meetingId', self.curMeetingId)
            params.append('caseId', self.curCaseId)
          if(this.docsendForm.type == 'GZZC_OTHER'){
            if(this.docsendForm.docName=='') {
              toastWarning('请输入文书名')
              return;
            }else
              params.append('fileName', this.docsendForm.docName+'.'+getFileExtendName(self.docsendForm.fileName))
          }else {
            params.append('fileName', self.docsendForm.fileName)
          }
            if (this.docsendForm.type == 'GZZC_MEDIATION_STAMP' || this.docsendForm.type == 'GZZC_BACKOUT_DECISION_BOOT_STAMP') {
                if (self.docsendForm.picFiles) {
                    self.docsendForm.picFiles.forEach(item => {
                        params.append('uploadFile', item)
                    })
                } else {
                    this.$message.warning('请上传文书')
                    return
                }
            } else {
                if (self.docsendForm.files) {
                    params.append('uploadFile', self.docsendForm.files)
                } else {
                    this.$message.warning('请上传文书')
                    return
                }
            }



            self.BtnLoading = true
            params.append('docType', dtype == 0 ? self.docsendForm.type : 'TRIAL_RECORD')
            console.log(params)
            sendAsyncMediationDoc(params).then(res => {
                console.log(res)
                if (res.data.code === 1000) {
                    self.$refs["docsendForm"].resetFields();
                    self.$refs.upload.clearFiles();
                    self.fileUploads.fileList = []
                    self.dialogVisible = false
                    self.$emit('loadPage')
                } else {
                    self.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
                self.BtnLoading = false
            }, err => {
                self.BtnLoading = false
            })
        },
        downLoadTemplate() {
            let temp = this.docsendForm.docTemp
            console.log('没有key会报错', temp)
            if (temp && temp.value) {
                let url = temp.value
                console.log('下载url-----', url)
                window.open(url)
            } else {
                console.log('weishameizou')
                this.$message({
                    message: "暂无模版,请于管理平台上传模版",
                    type: 'error'
                })
            }
        },
    }
}
</script>

<style lang="scss">
.doc_send_make_dialog {
    .el-dialog__body {
        padding: 25px 25px 0;
    }

    .doc_send_wrap {
        margin: 0 25px;

        .doc_template {
            margin-left: 15px;
            text-decoration: underline;
            color: #428BC6;
            cursor: pointer;
        }

        iframe {
            width: 750px;
            height: 600px;
            border: 0;
            border: 1px solid #efefef;
        }

        .upload-doc {
            .el-upload {
                width: 100%;
                text-align: left;
                padding-left: 8px;
            }
        }

        .doc_type {
            width: 100%;
        }
    }

    .dialog-footer {
        padding-bottom: 20px;

        .el-button {
            width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
